<template>
  <div>
    <h3 class="row mt-3 ml-2">
      キャラクター
      <v-spacer />
      <AddItemActor @resetList="resetList" />
    </h3>
    <v-row class="mt-2 ml-6 mb-4">
      <v-layout child-flex>
        <v-data-table
          :headers="headerActor"
          :items="listActor"
          :key="keyListActor"
          class="elevation-1"
          :items-per-page="listActor.length"
          :loading="loading"
          loading-text="読み込み中。。。待ってください。"
          hide-default-footer
        >
          <template v-if="listActor.length > 0" v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item, index) in items" :key="item.name">
                <td class="text-center">
                  <img height="50" :src="item.image" class="my-2" />
                </td>
                <td>{{ item.actor_name }}</td>
                <td class="multiline">{{ item.content.ja }}</td>
                <td class="text-center">
                  <template v-if="item.audio_url">
                    <audio :ref="`audio-${index}`">
                      <source :src="item.audio_url" type="audio/mp3" />
                      Your browser does not support the audio element.
                    </audio>
                    <v-btn
                      color="warning"
                      fab
                      height="30"
                      width="30"
                      dark
                      @click="play(`audio-${index}`)"
                    >
                      <v-icon small>fas fa-volume-up</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-row class="ma-0" align="center" justify="center">
                      <base-upload type="audio" v-model="audio">
                        <div slot="activator">
                          <v-btn fab small icon @click="itemUpdate = item"
                            ><v-icon>fas fa-upload</v-icon></v-btn
                          >
                        </div>
                      </base-upload>
                    </v-row>
                  </template>
                </td>

                <td class="text-center">
                  <!-- update item actor -->
                  <UpdateItemActor
                    :item="item"
                    @resetList="handleGetListActor"
                  />

                  <!-- delete item actor -->
                  <DeleteItemActor
                    :item="item"
                    @resetList="handleGetListActor"
                  />
                </td>
              </tr>
            </tbody>
          </template>
          <template v-slot:no-data>データがありません。</template>
        </v-data-table>
      </v-layout>
    </v-row>
  </div>
</template>

<script>
import AddItemActor from "@/views/listSection/Skit/acTor/AddItemActor.vue";
import { getListActor, updateActor } from "@/api/Actor.api";
import UpdateItemActor from "@/views/listSection/Skit/acTor/UpdateItemActor.vue";
import DeleteItemActor from "@/views/listSection/Skit/acTor/DeleteItemActor.vue";
import uploadFile from "@/utils/uploadFile";

export default {
  components: {
    AddItemActor,
    UpdateItemActor,
    DeleteItemActor,
  },
  data() {
    return {
      headerActor: [
        {
          text: "アバター",
          key: "image",
          value: "image",
          align: "center",
        },
        {
          text: "人物名",
          key: "actor_name",
          sortable: false,
          value: "actor_name",
        },
        {
          text: "セリフ",
          sortable: false,
          key: "content",
          value: "content.ja",
        },
        {
          text: "音声データ",
          sortable: false,
          key: "audio",
          value: "audio_url",
          width: "100px",
        },
        { text: "操作", align: "center", value: "actions", sortable: false },
      ],
      listActor: [],
      loading: false,
      keyListActor: 0,
      audioPlay: "",
      audio: null,
      itemUpdate: {},
    };
  },
  async created() {
    await this.handleGetListActor();
  },
  watch: {
    audio: function (val) {
      if (val !== null) {
        this.handleUpdateActor();
      }
    },
  },
  methods: {
    async handleGetListActor() {
      this.keyListActor++;
      this.loading = true;
      let params = {
        keyword: "",
        sub_key: this.$route.params.skit,
      };
      this.loadingListActor = true;
      await getListActor(params)
        .then((data) => {
          this.listActor = data.result;
        })
        .catch((error) => {
          console.log(error);
        });
      this.loading = false;
    },
    async resetList() {
      await this.handleGetListActor();
    },
    async handleUpdateActor() {
      const { Id, actor_name, isAvatar, content } = this.itemUpdate;
      this.loading = true;
      let params = {
        conversation_id: this.$route.params.skit,
        section_id: this.$route.params.section,
        id: Id,
        detail: {
          audio: this.audio,
          image: isAvatar,
          actor_name,
          content,
        },
      };
      params = await this.checkFile(params);
      await updateActor(params).then(() => {
        this.resetList();
      });
    },
    async checkFile(params) {
      if (params.detail.audio && params.detail.audio.file) {
        await uploadFile(params.detail.audio.file, "audio").then((e) => {
          params.detail.audio = e;
        });
      }
      return params;
    },
    play(ref) {
      const { _ } = this;
      if (!this.audioPlay || this.audioPlay == ref) {
        if (this.$refs[ref][0].paused) {
          this.$refs[ref][0].play();
        } else {
          this.$refs[ref][0].pause();
        }
        this.audioPlay = ref;
      } else if (this.audioPlay && this.audioPlay != ref) {
        if (this.$refs[ref][0].paused) {
          _.forEach(this.$refs, (e) => {
            e[0].pause();
          });
          this.$refs[ref][0].play();
        }
        this.audioPlay = ref;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#Audio {
  height: 40px;
  margin-top: 4px;
}
.multiline {
  font-family: inherit;
  font-family: inherit;
  white-space: pre-line;
  word-break: break-word;
}
</style>